// @ts-check

import React from "react";
import { BlockStack, FormLayout, TextField } from "@shopify/polaris";

import { AutoField } from "components/AutoField/AutoField";

import { useUtmLinks } from "context/UtmLinksContext";

export const CreateFacebookUtmLink = () => {
  const {
    baseUrl,
    setBaseUrl,
    utmSource,
    setUtmSource,
    utmMedium,
    setUtmMedium,
    utmCampaign,
    setUtmCampaign,
    utmContent,
    setUtmContent,
    utmTerm,
    setUtmTerm,
  } = useUtmLinks();

  const deselectedOptions = [
    { value: "{{site_source_name}}", label: "{{site_source_name}}" },
    { value: "{{placement}}", label: "{{placement}}" },
    { value: "{{campaign.name}}", label: "{{campaign.name}}" },
    { value: "{{adset.name}}", label: "{{adset.name}}" },
    { value: "{{ad.name}}", label: "{{ad.name}}" },
    { value: "{{ad.id}}", label: "{{ad.id}}" },
    { value: "{{adset.id}}", label: "{{adset.id}}" },
    { value: "{{campaign.id}}", label: "{{campaign.id}}" },
  ];

  return (
    <BlockStack gap="400">
      <BlockStack gap="300">
        <p>
          Adding UTM snippets to your active ads in the Meta
          (Facebook) Ads manager is the best way to ensure that
          your sales will be tracked and attributed correctly. The
          Ads manager allows you to use special placeholder values
          called URL macros in your UTM snippets that will resolve
          to the correct values when the ad is served.
        </p>
        <p>
          So, if you use the URL macro{" "}
          <b>{"{{site_source_name}}"}</b> in the source field of
          your UTM snippet, it will automatically resolve to the
          name of the source or site that the ad is served from
          (ig, fb, etc.).
        </p>
      </BlockStack>

      <FormLayout>
        <TextField
          label="Site Domain"
          value={baseUrl}
          onChange={setBaseUrl}
          placeholder="https://domain.com"
          helpText="The full URL for your domain (https://example.com)"
          autoComplete=""
        />

        <AutoField
          label="Source"
          deselectedOptions={deselectedOptions}
          inputValue={utmSource}
          setInputValue={setUtmSource}
          helpText="Site source of the traffic (fb, ig, email, etc.)"
        />

        <AutoField
          label="Medium"
          deselectedOptions={deselectedOptions}
          inputValue={utmMedium}
          setInputValue={setUtmMedium}
          helpText="Medium by which the traffic arrived (blog-post, facebook-feed, etc.)"
        />

        <AutoField
          label="Campaign"
          deselectedOptions={deselectedOptions}
          inputValue={utmCampaign}
          setInputValue={setUtmCampaign}
          helpText="Campaign attributed to this traffic (cyber-monday, black-friday, etc.)"
        />

        <AutoField
          label="Content"
          deselectedOptions={deselectedOptions}
          inputValue={utmContent}
          setInputValue={setUtmContent}
          helpText="Used to specify the content of the source. For Facebook ads, this could be the ad name"
        />

        <AutoField
          label="Term"
          deselectedOptions={deselectedOptions}
          inputValue={utmTerm}
          setInputValue={setUtmTerm}
          helpText="Arbitrary value that can be used for tracking whatever value you'd like"
        />
      </FormLayout>
    </BlockStack>
  );
};
